import { useEffect } from 'react';

const { api } = require('@cashew/utils');

export default function usePolling(
  action: any,
  delay: number,
  iterations: number,
  id: number | string
) {
  let timer = 0;
  const counts = iterations;

  const checkResult = () => {
    api
      .get({
        endpoint: `customers/profile-update-request/${id}`,
      })
      .then((result: any) => {
        const { status } = result.data;
        if (status === 'PENDING') {
          if (counts - 1 > timer) {
            timer += 1;
            setTimeout(() => {
              checkResult();
            }, delay * 1000);
          }
        } else if (status === 'VERIFIED') {
          action('success');
        } else if (status === 'EXPIRED') {
          action('warning');
        }
      })
      .catch((e: any) => {
        console.log('ERROR', e);
      });
  };

  useEffect(() => {
    if (id && iterations !== 0) {
      checkResult();
    }
  }, [id, iterations]);
}
